import React from 'react';
import GroupChip from '../SearchGroupsField/GroupChip';
import './index.sass';

export const DisabledChipsField = props => (
  <div className="disabled-chips-field">
    {props.data.map(title => <GroupChip key={title} disabled text={title} />)}
  </div>
);
